export class ExchangeConnectModel {
    enable: boolean;
    type = 'Graph';
    connectPara?: ConnectPara;
    connectInfo: ConnectInfo;
}

export class ConnectInfo {
    connectPara: {
        clientId: string;
        clientSecret: string;
        tenant: string;
    };
}

export class ConnectPara {
    clientId: string;
    clientSecret: string;
    tenant: string;
}

export class ExchangeConfigInfo {
    enable: boolean;
    deleteCategoryWhenEntryDelete: boolean;
    setting: SettingConfig;
}

export class SettingConfig {
    default: DefaultConfig;
}

export class DefaultConfig {
    name: string;
    color: string;
}

